/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureLabelSchema } from './CaptureLabelSchema';
import {
    CaptureLabelSchemaFromJSON,
    CaptureLabelSchemaFromJSONTyped,
    CaptureLabelSchemaToJSON,
    CaptureLabelSchemaToJSONTyped,
} from './CaptureLabelSchema';

/**
 * 
 * @export
 * @interface CreateCaptureLabelResponse
 */
export interface CreateCaptureLabelResponse {
    /**
     * 
     */
    label: CaptureLabelSchema;
}

/**
 * Check if a given object implements the CreateCaptureLabelResponse interface.
 */
export function instanceOfCreateCaptureLabelResponse(value: object): value is CreateCaptureLabelResponse {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CreateCaptureLabelResponseFromJSON(json: any): CreateCaptureLabelResponse {
    return CreateCaptureLabelResponseFromJSONTyped(json, false);
}

export function CreateCaptureLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaptureLabelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'label': CaptureLabelSchemaFromJSON(json['label']),
    };
}

export function CreateCaptureLabelResponseToJSON(json: any): CreateCaptureLabelResponse {
    return CreateCaptureLabelResponseToJSONTyped(json, false);
}

export function CreateCaptureLabelResponseToJSONTyped(value?: CreateCaptureLabelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': CaptureLabelSchemaToJSON(value['label']),
    };
}

